/**
 * Kiểu dùng chung cho các bảng danh sách trong nhóm trang quản lý — gom về
 * một chỗ để 5 trang (Hợp tác xã, Sọt, Chủ vườn/Vườn, Loại bơ & giá, Tài
 * khoản) không trôi dạt mỗi trang một kiểu bảng.
 */

import { SEMANTIC } from "assets/theme/avocadoBrand";

/**
 * Kiểu chữ cho ô tiêu đề cột: chữ hoa nhỏ giãn rộng trên nền xám ấm — cùng
 * ngôn ngữ với nhãn "eyebrow" ở đầu trang, để bảng đọc như một biểu kê.
 *
 * Truyền thẳng vào prop `sx` của `TableCell` (là style function nhận theme):
 * `<TableCell sx={oTieuDeCot}>` hoặc gộp với kiểu khác qua mảng:
 * `<TableCell sx={[oTieuDeCot, AN_DUOI_MD]}>`.
 */
export const oTieuDeCot = ({ palette, typography }) => ({
  py: 1.25,
  fontSize: typography.size.xxs,
  fontWeight: typography.fontWeightMedium,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  color: palette.text.main,
  backgroundColor: palette.grey[100],
  whiteSpace: "nowrap",
});

/**
 * Ẩn một cột phụ dưới breakpoint `md`. Từ md trở lên mỗi thông tin có cột
 * riêng; dưới md các cột phụ bị ẩn nên phải gom lại thành một dòng nhỏ ngay
 * dưới ô chính (xem các component `ThongTinPhu` trong từng trang) — không mất
 * dữ liệu, cũng không bắt người dùng kéo ngang bảng nhiều cột trên điện thoại.
 */
export const AN_DUOI_MD = { display: { xs: "none", md: "table-cell" } };

/**
 * Ẩn cột dưới breakpoint `sm` (vd cột checkbox chọn hàng loạt, cột phụ hẹp
 * hơn md nhưng vẫn quá rộng trên điện thoại ~320px).
 */
export const AN_DUOI_SM = { display: { xs: "none", sm: "table-cell" } };

/**
 * Text nghiệp vụ dài (email, địa chỉ, mã, tên ghép) xuống dòng thay vì đẩy
 * ngang bảng/dialog. Gắn vào `sx` của Typography hoặc TableCell.
 */
export const chuXuongDong = {
  wordBreak: "break-word",
  overflowWrap: "anywhere",
};

/**
 * Viền ô bảng kiểu Excel (chứng từ đối chiếu) — SEMANTIC.borderStrong
 * thay cho hex `#d5d9dd` rải rác.
 */
export const oVienBangExcel = {
  border: `1px solid ${SEMANTIC.borderStrong}`,
};
